import { render } from "./ProductCardSlide.vue?vue&type=template&id=e9f47bee&scoped=true"
import script from "./ProductCardSlide.vue?vue&type=script&lang=js"
export * from "./ProductCardSlide.vue?vue&type=script&lang=js"

import "./ProductCardSlide.vue?vue&type=style&index=0&id=e9f47bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9f47bee"]])

export default __exports__